module.exports = __webpack_public_path__ + "static/img/bg-tr.42344970.png";